import { useContext } from 'react';
import { useSelector } from 'react-redux';
import HeaderLayout from '../../../components/Layout/Header/HeaderLayout';
import SimulatorRendersFunds from '../../../components/simulator/SimulatorRendersFunds';
import ModalErrorFetch from '../../../components/UI/ModalErrorFetch';
import { InvestmentContext } from '../../../context/InvestmentContext';
import useModal from '../../../hooks/custom/useModal';
import useGetSimulatorList from '../../../hooks/useGetSimulatorList';
import { onRefresh } from '../../../utils/refreshPage';
import { getFirstElement } from '../../../utils/utils';

const SimulatorFunds = () => {
  const { isShowing, toggle } = useModal();
  const securitySelected = useSelector(state => state.simulation.securitySelected);

  const { send, setSend, formData, setFormData, setFormDataAndPersist } =
    useContext(InvestmentContext);

  // service to simulate data funds
  const [
    doGetSimulatorList,
    { data: dataSimulationFunds, error: errorSimulationFunds, loading: loadingSimulationFunds },
  ] = useGetSimulatorList();

  const custom = JSON.parse(securitySelected.Custom);
  const motivations = getFirstElement(custom?.preferences.motivaciones);
  const interests = getFirstElement(custom?.preferences.intereses);
  const motivationsId = custom?.preferences.motivaciones[0].id;
  const risk = custom?.preferences.riesgo.description;
  const interestsId = custom?.preferences.intereses[0].id;

  const fileAs = {
    currency: custom.fund_details.currency,
    fileAs: 'FileAsName',
    fileAsComplete: securitySelected?.Name?.slice(4),
    risk: risk,
    motivation: motivations?.split('-')[0],
    motivationId: motivationsId,
    interests: interests,
    interestsId: interestsId,
    products: true,
    profit: securitySelected?.profit,
  };

  if (errorSimulationFunds) {
    return (
      <ModalErrorFetch
        message='Lo sentimos, algo no salio bien acá....'
        error={errorSimulationFunds}
        open={!isShowing}
        onClose={toggle}
        refresh={onRefresh}
      />
    );
  }

  return (
    <>
      <HeaderLayout mode='funds' type='product' fileAs={fileAs} />
      <SimulatorRendersFunds
        send={send}
        setSend={setSend}
        formData={formData}
        setFormData={setFormData}
        securitySelected={securitySelected}
        doGetSimulatorList={doGetSimulatorList}
        loadingSimulationFunds={loadingSimulationFunds}
        setFormDataAndPersist={setFormDataAndPersist}
      />
    </>
  );
};

export default SimulatorFunds;
